/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-axes-ticks-font-family',
  templateUrl: './theme-option-axes-ticks-font-family.component.html',
  styleUrls: ['./theme-option-axes-ticks-font-family.component.css']
})
export class ThemeOptionAxesTicksFontFamilyComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() axesIndex: number;
  @Input() axesXY: 'x' | 'y';

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'axes_ticks_fontFamily';
  showDetails: boolean;

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  receiveValue(value: string, type?: ChartType) {
    this.themeOptions.setAxes(this.optionType, value, this.axesXY, this.axesIndex, type ? [type] : undefined);
  }

}
